import { Subject } from "rxjs";
import { CuotaDTO, TagDTO } from "@DTOS";

export class Cuota {
    public cuotaDTO: CuotaDTO;
    public cambioActivado = new Subject<boolean>();
    public recalcularDatosAlActivar = true;
    private _activado: boolean;

    constructor(public valor: number, activado: boolean, public tag: TagDTO) {
        this.activado = activado;
    }

    public get activado() {
        return this._activado;
    }

    public set activado(activado: boolean) {
        this._activado = activado;
        this.cambioActivado.next(this.recalcularDatosAlActivar);
        this.recalcularDatosAlActivar = true;
    }
}
